import { graphql, useStaticQuery } from 'gatsby'
import { AltImage } from '../types/imageSanity'
import { imageUrlFor } from '../lib/image-url'
import { buildImageObj } from '../lib/helpers'

interface SEOProps {
  description?: string | null
  title: string
  image?: AltImage | null
}

const detailsQuery = graphql`
  query SEO {
    site: sanitySiteSettings(_id: { eq: "siteSettings" }) {
      title
      description
      author {
        name
      }
    }
  }
`

function SEO({ description, title, image }: SEOProps) {
  const data = useStaticQuery<Queries.SEOQuery>(detailsQuery)

  const metaDescription = description || ''
  const siteTitle = data.site?.title || ''
  const siteAuthor = data.site?.author?.name || ''
  const metaImage = image?.asset
    ? imageUrlFor(buildImageObj(image)).width(1200).url()
    : ''

  return (
    <>
      <title>
        {title === siteTitle ? siteTitle : `${title} - ${siteTitle}`}
      </title>
      <meta name="description" content={metaDescription} />
      <meta name="og:title" content={title} />
      <meta name="og:description" content={metaDescription} />
      <meta name="og:type" content="website" />
      <meta name="og:image" content={metaImage} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={siteAuthor} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
    </>
  )
}

SEO.defaultProps = {
  image: undefined,
}

export default SEO
